/**
 * Stops number fields changing their value behind the user's back.
 *
 * A browser steps an `<input type="number">` up or down on ArrowUp and ArrowDown, and on the mouse
 * wheel while it has focus. The spinner arrows are hidden app-wide (index.css), so nothing on screen
 * says the field responds to either. A keyboard user arrowing through a form turned a quantity of 10
 * into 9 without noticing, and scrolling the page with the pointer over a focused price nudged it.
 *
 * Installed once, from index.js, on the document, so every number field is covered without each form
 * having to remember. A field that really does want arrow stepping can opt back in with
 * `data-arrow-step`.
 */
export function installNumberInputGuard(doc = document) {
  const isNumberField = (el) =>
    el instanceof HTMLInputElement && el.type === 'number' && !el.hasAttribute('data-arrow-step');

  const onKeyDown = (e) => {
    if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && isNumberField(e.target)) e.preventDefault();
  };

  // Blurring rather than preventing the wheel keeps the page scrolling; the browser only steps a
  // number field while it has focus.
  const onWheel = (e) => {
    const active = doc.activeElement;
    if (isNumberField(active) && active === e.target) active.blur();
  };

  doc.addEventListener('keydown', onKeyDown, true);
  doc.addEventListener('wheel', onWheel, { capture: true, passive: true });
  return () => {
    doc.removeEventListener('keydown', onKeyDown, true);
    doc.removeEventListener('wheel', onWheel, { capture: true, passive: true });
  };
}
